// src/translations/en/shopPage.lang.en.js

const shopPageEN = {
	errorLoading: "We couldn't load this business. Please try again.",
	rating: {
		reviews: "{{count}} reviews",
	},
	searchServices: "Search services",
	status: {
		open: "Open",
		closed: "Closed",
		until: "until",
		opensAt: "opens",
		tomorrow: "tomorrow",
	},
	gallery: {
		back: "Back",
		share: "Share",
		linkCopied: "Link copied",
		noPhotos: "No photos yet",
		photo: "Photo",
		photos: "photos",
		photosOne: "photo",
		previous: "Previous",
		next: "Next",
		close: "Close",
	},
	main: {
		services: "Services",
		book: "Book",
		noServices: "No services listed yet.",
		reviews: "Reviews",
		noReviews: "No reviews yet",
		attributes: "Attributes",
		noAttributes: "No attributes yet",
		info: "Shop Info",
		about: "About",
		searchServices: "Search for a service",
		anonymous: "Anonymous",
		newShop: "New on Sin Fila",
		reportReview: "Report review",
		serviceType: {
			home: "Home service",
			online: "Online",
		},
	},
	sidebar: {
		description: "Description",
		location: "Location",
		information: "Information",
		staff: "Staff",
		contactAndHours: "Contact & Business Hours",
		noPhone: "No phone available",
		call: "Call",
		getDirections: "Get Directions",
		hours: {
			title: "Business hours",
			today: "Today",
			closed: "Closed",
			showWeek: "Show full week",
			hideWeek: "Hide full week",
		},
		websiteTitle: "Website",
		socialTitle: "Social Media",
	},
};

export default shopPageEN;
